import ConnectedMoneySliderRange from "components/screener/shared/ConnectedMoneySliderRange";

export default function MarketCapitalization() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Market Cap</h3>
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Filtre pelo Valor de Mercado.
        </span>
      </div>

      <ConnectedMoneySliderRange
        attribute="marketCapitalization"
        label="Market Cap"
        accessibilityLabels={["Market Cap mínimo", "Market Cap máximo"]}
      />
    </div>
  );
}
